import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Reset Settings Tab
 */
import React from "react";
import { useSettingsContext } from "../SettingsContext";
import { useWidgetI18n } from "../../../context/WidgetI18nContext";
import styles from "./settingsTabs.module.css";
export function ResetSettingsTab(props) {
    const { onReset } = props;
    const { resetAll } = useSettingsContext();
    const { t } = useWidgetI18n();
    const handleReset = () => {
        resetAll();
        onReset?.();
    };
    return (_jsx("div", { className: styles.tabContainer, children: _jsxs("div", { className: styles.section, children: [_jsx("h4", { className: styles.sectionTitle, children: t("settings.resetKicker") || "Reset Settings" }), _jsxs("div", { className: styles.row, children: [_jsxs("div", { children: [_jsx("div", { style: { fontSize: 13, fontWeight: 600, color: "var(--vnsc-text-primary, #f1f5f9)" }, children: t("settings.resetDefaults") || "Reset all chart settings" }), _jsx("div", { className: styles.subLabel, children: t("settings.resetNote") || "This will restore pane sizes, colors, and indicators to default." })] }), _jsx("button", { type: "button", className: styles.btnSm, style: { color: "#ef5350", borderColor: "rgba(239, 83, 80, 0.4)", padding: "8px 16px" }, onClick: handleReset, children: t("settings.resetLayout") || "Reset to Default" })] })] }) }));
}
